import { registerView, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Alert, Col, Row } from "react-bootstrap";
import AlertViewModel from "viewModels/alertViewModel";
import Icon from "@edaz/edazkit/Icon";

const alertView: ViewComponent<AlertViewModel> = observer(({ vm }) => {
  let alertContent;

  const alertSectionClassName = `d-flex flex-row ${
    vm.notification.contentCenter ? "justify-content-center" : ""
  } align-items-center`;

  if (vm.notification.action) {
    // Action title supplied - create link with action title on the right side of alert
    if (vm.notification.action.title) {
      alertContent = (
        <div className="d-flex justify-content-between align-items-center">
          <div className={alertSectionClassName}>
            {vm.notification.icon && (
              <Icon
                className="mr-2"
                icon={vm.notification.icon}
                width={vm.notification.iconWidth || 24}
                height={vm.notification.iconHeight || 24}
              />
            )}
            <span>{vm.notification.title}</span>
          </div>
          <a href={vm.notification.action.link} onClick={vm.notification.action.func}>
            {vm.notification.action.title}
          </a>
        </div>
      );
    } else {
      // Action title NOT supplied - create link with as alert's main content
      alertContent = (
        <a href={vm.notification.action.link} onClick={vm.notification.action.func}>
          <div className={alertSectionClassName}>
            {vm.notification.icon && (
              <Icon
                className="mr-2"
                icon={vm.notification.icon}
                width={vm.notification.iconWidth || 24}
                height={vm.notification.iconHeight || 24}
              />
            )}
            <span>{vm.notification.title}</span>
          </div>
        </a>
      );
    }
  } else {
    // Just static alert without any action/link
    alertContent = (
      <div className={alertSectionClassName}>
        <Row>
          {vm.notification.icon && (
            <Col xs="auto" className="mr-0 pr-1 align-items-center d-flex flex-row">
              <Icon
                className="mr-2"
                icon={vm.notification.icon}
                width={vm.notification.iconWidth || 24}
                height={vm.notification.iconHeight || 24}
              />
            </Col>
          )}
          <Col className="ml-0 pl-1 align-items-center d-flex flex-row">
            <span>{vm.notification.title}</span>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <Alert className="border-none" variant={vm.variant} dismissible={!!vm.onClose} closeLabel="&times;" onClose={vm.onClose}>
      {alertContent}
    </Alert>
  );
});

export default registerView(alertView, AlertViewModel);
